import { Toggle } from '@atlas/ui-kit'
import { DetailsCard, YesToggle } from './DetailsCard'
import type { LegalFlag } from './pack-form'

/** One Legal Content row as the card shows it. */
export interface LegalContentRow {
	flag: LegalFlag
	label: string
	/** The row's text; null when nothing holds it. */
	text: string | null
	/** What the row reads when it has no text, e.g. "No source yet". */
	emptyText: string
	isApplicable: boolean
}

/**
 * Legal Content: which legal texts the piece carries. The texts are read-only; the PM sets
 * whether each applies, and whether the piece carries legal content at all.
 */
export function LegalContentCard({
	isOn,
	onToggle,
	rows,
	onToggleRow,
}: {
	isOn: boolean
	/** Absent when the card is read-only. */
	onToggle?: (isOn: boolean) => void
	rows: readonly LegalContentRow[]
	onToggleRow?: (flag: LegalFlag, isApplicable: boolean) => void
}) {
	return (
		<DetailsCard
			title="Legal Content"
			action={<YesToggle label="The piece carries legal content" isSelected={isOn} onChange={onToggle} />}
		>
			{isOn ? (
				<ul className="flex flex-col gap-8">
					{rows.map((row) => (
						<li key={row.flag} className="flex flex-col gap-1.5">
							<div className="flex items-center gap-1">
								<span className="flex-1 text-atlas-label text-atlas-light-dark">{row.label}</span>
								<span aria-hidden="true" className="text-atlas-body-medium text-atlas-dark">
									Applicable
								</span>
								<Toggle
									className="ml-2"
									aria-label={`${row.label} applicable`}
									isSelected={row.isApplicable}
									isDisabled={!onToggleRow}
									onChange={(isApplicable) => onToggleRow?.(row.flag, isApplicable)}
								/>
							</div>
							<p className="whitespace-pre-line text-atlas-body text-atlas-dark">
								{row.isApplicable ? (row.text ?? row.emptyText) : 'Not applicable N/A'}
							</p>
						</li>
					))}
				</ul>
			) : null}
		</DetailsCard>
	)
}
